import React, { useState, useEffect } from 'react'
import { Box, Flex, Group, Button, Stepper, TextInput, Checkbox, Grid, Text, Tooltip, Paper, Image, ThemeIcon, SimpleGrid, Input, NumberInput, Select } from '@mantine/core'
import { useParams } from 'react-router-dom'
import { IconCircleCheck, IconShoppingCart, IconInfoSquare, IconPackage, IconInfoCircle } from '@tabler/icons-react'
import { getDetailOrder } from '../../../../../services/orders'
import LoadingData from '../../../../ui/LoadingData'
import NoData from '../../../../ui/NoData'
import NoImage from '../../../../../assets/img/images/no-images.png'
import { notificationSuccess, notificationError } from '../../../../ui/Notifications'
import { validation } from '../../../../../plugins/validation'
import { bundleUnit } from '../../../../../helper/master-unit'
import { addPackingList, updatePackingList } from '../../../../../services/packing'
import { useDispatch } from 'react-redux'
import { getPackageDetail } from '../../../../../store/packageDetail'

const defaultQtyUnit = [
  { value: 'pcs', label: 'Pcs' },
  { value: 'sheets', label: 'Sheets' },
  { value: 'boxes', label: 'Boxes' },
]

const defaultDimensionUnit = [
  { value: 'meters', label: 'Meters' },
  { value: 'inchs', label: 'Inchs' },
  { value: 'cms', label: 'Centimeters' }
]

const defaultValItem = [
  {
    item_id: '',
    product_name: '',
    qty: 0,
    qty_unit: 'pcs',
  }
]

const formValidationItems = {
  qty: {
    isError: false,
    message: '',
  },
  qty_unit: {
    isError: false,
    message: '',
  },
}

const defaultValDetail = {
  marks: '',
  package_qty: '1',
  package_type: 'crt',
  item_qty: '',
  item_qty_unit: '',
  net_weight: '',
  gross_weight: '',
  width: '',
  height: '',
  length: '',
  dimension_unit: 'meters'
}

const formValidationDetail = {
  marks: {
    isError: false,
    message: ''
  },
  package_qty: {
    isError: false,
    message: ''
  },
  package_type: {
    isError: false,
    message: ''
  },
  item_qty: {
    isError: false,
    message: ''
  },
  item_qty_unit: {
    isError: false,
    message: ''
  },
  net_weight: {
    isError: false,
    message: ''
  },
  gross_weight: {
    isError: false,
    message: ''
  },
  width: {
    isError: false,
    message: ''
  },
  height: {
    isError: false,
    message: ''
  },
  length: {
    isError: false,
    message: ''
  },
  dimension_unit: {
    isError: false,
    message: ''
  },
}

const FormAdjustPackageItem = ({ dataItem, onCloseForm, reloadList }) => {
  const dispatch = useDispatch()
  const params = useParams()
  const orderId = params.order_id
  const packageId = params.package_id
  const [loadingProduct, setLoadingProduct] = useState(true)
  const [loadingForm, setLoadingForm] = useState(false)
  const [productList, setProductList] = useState([])
  const [searchProduct, setSearchProduct] = useState('')
  const [selectedProduct, setSelectedProduct] = useState([])
  const [activeStepForm, setActiveStepForm] = useState(0)
  const [formDataItems, setFormDataItems] = useState(defaultValItem)
  const [validationFormItems, setValidationFormItems] = useState(formValidationItems)
  const [formDataDetail, setFormDataDetail] = useState(defaultValDetail)
  const [validationFormDetail, setValidationFormDetail] = useState(formValidationDetail)


  const submitPackageItems = async () => {
    setLoadingForm(true)
    setValidationFormDetail(formValidationDetail)
    let methodFunction = null
    let titleMessageSuccess = ''
    let captionMessageSuccess = ''
    let titleMessageError = ''
    let captionMessageError = ''
    const remapItemPackage = formDataItems.map((val) => {
      return {
        item_id: Number(val.item_id),
        qty: Number(val.qty),
        qty_unit: val.qty_unit
      }
    })
    const totalQty = formDataItems.reduce((accumulator, currentValue) => { return  accumulator + currentValue.qty }, 0)
    const validateDetail = {
      marks: formDataDetail.marks,
      package_qty: `${formDataDetail.package_qty}`,
      package_type: formDataDetail.package_type,
      item_qty: `${totalQty}`,
      item_qty_unit: formDataDetail.package_type,
      net_weight: `${formDataDetail.net_weight}`,
      gross_weight: `${formDataDetail.gross_weight}`,
      width: `${formDataDetail.width}`,
      height: `${formDataDetail.height}`,
      length: `${formDataDetail.length}`,
      dimension_unit: formDataDetail.dimension_unit
    }
    const isError = validation(validateDetail, setValidationFormDetail)
    if (isError) {
      setLoadingForm(false)
      return 
    }
    if (dataItem === null) {
      const payload = {
        order_id: Number(orderId),
        package_id: Number(packageId),
        marks: formDataDetail.marks,
        package_qty: Number(formDataDetail.package_qty),
        package_type: formDataDetail.package_type,
        item_qty: totalQty,
        item_qty_unit: 'default',
        net_weight: Number(formDataDetail.net_weight),
        gross_weight: Number(formDataDetail.gross_weight),
        dimension: [
          {
            label: 'length',
            value: Number(formDataDetail.length),
          },
          {
            label: 'width',
            value: Number(formDataDetail.width),
          },
          {
            label: 'height',
            value: Number(formDataDetail.height),
          },
        ],
        dimension_unit: formDataDetail.dimension_unit,
        order_items: remapItemPackage,
      }
      methodFunction = await addPackingList(payload)
      titleMessageSuccess = 'Add Package Items Successfully'
      captionMessageSuccess = 'You have been added new package items'
      titleMessageError = 'Add Package Items Error'
    } else {
      const updatePayload = {
        marks: formDataDetail.marks,
        package_qty: Number(formDataDetail.package_qty),
        package_type: formDataDetail.package_type,
        item_qty: totalQty,
        item_qty_unit: formDataDetail.package_type,
        net_weight: Number(formDataDetail.net_weight),
        gross_weight: Number(formDataDetail.gross_weight),
        dimension: [
          {
            label: 'length',
            value: Number(formDataDetail.length),
          },
          {
            label: 'width',
            value: Number(formDataDetail.width),
          },
          {
            label: 'height',
            value: Number(formDataDetail.height),
          },
        ],
        dimension_unit: formDataDetail.dimension_unit,
        order_items: remapItemPackage,
      }
      methodFunction = await updatePackingList(dataItem.id, updatePayload)
      titleMessageSuccess = 'Update Package Items Successfully'
      captionMessageSuccess = 'You have been update package items'
      titleMessageError = 'Update Package Items Error'
    }
    try {
      const response = await methodFunction
      if (response.success) {
        notificationSuccess(titleMessageSuccess, captionMessageSuccess)
        if (reloadList === null) {
          dispatch(getPackageDetail(packageId))
        } else {
          reloadList()
        }        
        onCloseForm()
      } else {
        const responseMessage = response.message
        notificationError(titleMessageError, responseMessage)
      }
    } catch (error) {
      const errorMessage = error.response.data.message
      captionMessageError = Object.keys(errorMessage) ? errorMessage : 'Please recheck your form'
      notificationError(titleMessageError, captionMessageError)
    } finally {
      setLoadingForm(false)
    }
    
  }

  const fecthOrderProductsList = async () => {
    setLoadingProduct(true)
    const params = {
      include: 'items,invoices,platform,parent,child,packagaging'
    }
    try {
      const response = await getDetailOrder(orderId, params)
      if (response.success) {
        const responseData = response.data.attributes
        const getProductOrder = responseData.details || []
        const remapData = getProductOrder.map((val) => {
          return {
            ...val.attributes,
            id: `${val.attributes.id}`,
          }
        })

        const filterStatus = remapData.filter((val) => val.item_status[0].attributes.name === 'goods ready to be shipped')
        if (filterStatus.length === 0) {
          notificationError('Add Package Items Failed', 'All Order Items not goods ready to be shipped.')
          onCloseForm()
          return
        } else {
          const recentPackedItems = filterStatus.filter((val) => Number(val.quantity) - val.qty_packed > 0)
          setProductList(recentPackedItems)
        }     
      } else {
        setProductList([])
      }
      setLoadingProduct(false)
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingProduct(false)
    }
  }

  useEffect(() => {
    fecthOrderProductsList()
    // eslint-disable-next-line
  }, [orderId])

  useEffect(() => {
    if (dataItem !== null) {
      handleSetForm(dataItem)
    }
  }, [dataItem])

  const handleSetForm = (val) => {
    setActiveStepForm(1)
    const selectedItems = val.order_items.map((value) => {
      return value.id
    })
    setSelectedProduct(selectedItems)
    const remapFormDetail = val.order_items.map((value) => {
      return {
        item_id: value.item_id,
        product_name: value.name,
        qty: `${value.qty}`,
        qty_unit: value.qty_unit,
      }
    })
    setFormDataItems(remapFormDetail)
    const detail = {
      marks: val.marks,
      package_qty: `${val.package_qty}`,
      package_type: `${val.package_type}`,
      net_weight: `${val.net_weight}`,
      gross_weight: `${val.gross_weight}`,
      item_qty: `${val.item_qty}`,
      item_qty_unit: val.package_type,
      width: `${val.dimensions.find((val) => val.label === 'width').value}`,
      height: `${val.dimensions.find((val) => val.label === 'height').value}`,
      length: `${val.dimensions.find((val) => val.label === 'length').value}`,
      dimension_unit: val.unit_dimension
    }
    setFormDataDetail(detail)
  }

  const handlingSelectedItems = (dataProduct, selected) => {
    const selectedItems = dataProduct.filter((item) => selected.find((val) => val === item.id))
    const remapSelectedItems = selectedItems.map((val) => {
      return {
        item_id: val.id,
        product_name: val.product_name,
        qty: Number(val.quantity - val.qty_packed),
        qty_unit: val.unit_name,
      }
    })
    setFormDataItems(remapSelectedItems)
  }

  const handleNextStep = () => {
    if (activeStepForm === 0) {
      if (selectedProduct.length === 0) {
        notificationError('Select Product Items', 'Please select at least one product item to proceed.')
        return
      }
      nextStep()
    } else if (activeStepForm === 1) {
      setValidationFormItems(formValidationItems)
      let validateItems = {}
      for (let i = 0; i < formDataItems.length; i++) {
        validateItems = {
          qty: `${formDataItems[i].qty}`,
          qty_unit: formDataItems[i].qty_unit
        }
      }
      const isErrorItems = validation(validateItems, setValidationFormItems)
      if (isErrorItems) {
        notificationError('Please Input Product Item Specification', 'Check recheck your form specification')
        return
      }
      handleChangeForm('package_qty', selectedProduct.length)
      const totalQty = formDataItems.reduce((accumulator, currentValue) => { return  accumulator + currentValue.qty }, 0)
      handleChangeForm('item_qty', totalQty)
      nextStep()
    }
  }

  const nextStep = () => setActiveStepForm((current) => (current < 3 ? current + 1 : current))

  const prevStep = () => setActiveStepForm((current) => (current > 0 ? current - 1 : current))

  const handleChangeItems = (indexItems, labelName, value) => {
    const remapForm = formDataItems.map((val, index) => {
      if (index === indexItems) {
        return {
          ...val,
          [labelName]: value
        }
      } else {
        return val
      }
    })
    setFormDataItems([...remapForm])
  }

  const handleChangeForm = (name, val) => {
    setFormDataDetail((oldVal) => ({ ...oldVal, [name]: val}))
  }

  const loadForm = () => {

    const mappingFormItems = () => {
      const mappingItemsProduct = (items) => {
        const shouldFilterOptions = items.every((item) => item.product_name !== searchProduct)
        const filteredOptions = shouldFilterOptions ? items.filter((item) => item.product_name.toLowerCase().includes(searchProduct.toLowerCase().trim())) : items

        if (filteredOptions.length > 0) {
          const mappingDataVariant = (variants) => {
            if (variants.length > 0) {
              const remapVariants = variants.map((val, index) => {
                return (
                  <Box key={index} mb={2}>
                    <Text fz={10} fw={500}>{val.name}: {val.option}</Text>
                  </Box>
                )
              })
              return remapVariants
            } else {
              return (
                <Text fz={10}>This Product has no variants</Text>
              )
            }
          }

          const remapList = filteredOptions.map((val, index) => {
            return (
              <Grid.Col span={{ base: 12, md: 6, lg: 4, xl: 3 }}>
                <Checkbox.Card 
                  radius='md'
                  p='sm'
                  withBorder
                  value={val.id}
                  key={index}
                  disabled={dataItem !== null}
                  style={{ borderColor: selectedProduct.includes(val.id) ? 'red' : '' }}>
                  <Group justify="space-between" wrap="nowrap" align="flex-start">
                    <Box>
                      <Flex gap='xs' align='start'>
                        <Paper shadow="sm" w={42} withBorder radius='md'>
                          <Image w={40} h={40} radius='md' src={val.image_url !== null ? val.image_url : NoImage} />
                        </Paper>
                        <Text fz={10} fw={500} lineClamp={2}>{val.product_name}</Text>
                      </Flex>
                      <Box mt={10}>
                        <Text fz={10} fw={500} c='gray.6' mb={2}>Product Quantity: {Number(val.quantity)} {val.unit_name}</Text>
                        <Text fz={10} fw={500} c='gray.6'>Qty Left: {Number(val.quantity - val.qty_packed)} {val.unit_name}</Text>
                      </Box>
                      <Box ml={-6} mt={6}>
                        <Tooltip multiline w={300} withArrow label={mappingDataVariant(val.variants)}>
                          <Group gap={1} align='center'>
                            <ThemeIcon size='sm' variant="white" color="blue" radius='xl'>
                              <IconInfoCircle style={{ width: '70%', height: '70%' }} />
                            </ThemeIcon>
                            <Text fz={10} c='blue' fw={500}>Variant</Text>
                          </Group>
                        </Tooltip>
                      </Box>
                    </Box>
                    <Checkbox.Indicator />
                  </Group>
                </Checkbox.Card>
              </Grid.Col>
            )
          })
          return remapList
        } else {
          return (
            <Grid.Col span={12}>
              <NoData />    
            </Grid.Col>
          )
        }
      }

      const handlingInitForm = (val) => {
        handlingSelectedItems(productList, val)
      }

      return (
        <Box mih={580}>
          <Box mb='sm'>
            <TextInput
              name='searchProduct'
              value={searchProduct}
              onChange={(e) => setSearchProduct(e.target.value)}
              size='xs'
              label="Search Product"
            />
          </Box>
          <Box mb='sm'>
            <Checkbox.Group
              name="selectedProduct"
              value={selectedProduct}
              onChange={(val) => [setSelectedProduct(val), handlingInitForm(val)]}
              size='xs'
              label="Select Product Items"
              description="Select the product items you want to adjust in this package."
              withAsterisk
            >
              <Grid my={10} gutter='xs'>
                {mappingItemsProduct(productList)}
              </Grid>
            </Checkbox.Group>
          </Box>
        </Box>
      )
    }

    const mappingSelectedItems = () => {
      const dataItems = selectedProduct
      if (dataItems.length > 0) {
        const remapItems = dataItems.map((val, index) => {
          return (
            <SimpleGrid cols={3} verticalSpacing="sm" mb='sm'>
              <Box>
                <Input.Wrapper label='Product Name' size='xs' required>
                  <Text fz={12} fw={600} mt={5} lineClamp={1}>{formDataItems[index].product_name}</Text>
                </Input.Wrapper>
              </Box>
              <Box>
                <NumberInput
                  name='qty'
                  label="Product Quantity"
                  value={formDataItems[index].qty}
                  rightSection={<Text fz='xs' c='black' tt='capitalize'>{formDataItems[index].qty_unit}</Text>}
                  onChange={(value) => handleChangeItems(index, 'qty', value)}
                  error={validationFormItems.qty.isError ? `${validationFormItems.qty.message}` : ''}
                  placeholder='Input quantity'
                  size='xs'
                  withAsterisk
                  rightSectionWidth={45}
                />
              </Box>
              <Box>
                <Select
                  name='qty_unit'
                  value={formDataItems[index].qty_unit}
                  onChange={(value) => handleChangeItems(index, 'qty_unit', value)}
                  error={validationFormItems.qty_unit.isError ? `${validationFormItems.qty_unit.message}` : ''}
                  label='Product Unit'
                  placeholder='Select product unit'
                  data={defaultQtyUnit}
                  size='xs'
                  withAsterisk
                  allowDeselect={false}
                />
              </Box>
            </SimpleGrid>
          )
        })

        return (
          <Box mih={580}>
            <Text fz={14} fw='bold' mb={10}>Selected Items</Text>
            {remapItems}
          </Box>
        )
      } else {
        return (
          <Box mih={580} textAlign='center'>
            <Text fz={12} fw='bold' color='gray.6'>No Items Selected</Text>
          </Box>
        )
      }
    }

    const mappingFormDetail = () => {
      return (
        <Box mih={580}>
          <Text fz={14} fw='bold' mb={10}>Detail Package</Text>
          <SimpleGrid cols={3} verticalSpacing="sm" mb='sm'>
            <Box>
              <TextInput
                name='marks'
                value={formDataDetail.marks}
                label='Package Marks No.'
                error={validationFormDetail.marks.isError ? `${validationFormDetail.marks.message}` : ''}
                onChange={(val) => handleChangeForm('marks', val.target.value)}
                withAsterisk
                size='xs'
              />
            </Box>
            <Box>
              <Select
                name='package_type'
                value={formDataDetail.package_type}
                onChange={(value) => handleChangeForm('package_type', value)}
                error={validationFormDetail.package_type.isError ? `${validationFormDetail.package_type.message}` : ''}
                label='Choose Package'
                placeholder='Select package'
                data={bundleUnit}
                size='xs'
                withAsterisk
                allowDeselect={false}
              />
            </Box>
            <Box>
              <NumberInput
                name='package_qty'
                label="Package Quantity"
                value={formDataDetail.package_qty}
                rightSection={<Text fz='xs' c='black' tt='capitalize'>{formDataDetail.package_type}</Text>}
                onChange={(value) => handleChangeForm('package_qty', value)}
                error={validationFormDetail.package_qty.isError ? `${validationFormDetail.package_qty.message}` : ''}
                placeholder='Input quantity'
                size='xs'
                withAsterisk
                rightSectionWidth={45}
                disabled={selectedProduct.length > 1}
              />
            </Box>
            <Box>
              <NumberInput
                name='net_weight'
                label="N.W.(KGS)"
                value={formDataDetail.net_weight}
                onChange={(value) => handleChangeForm('net_weight', value)}
                error={validationFormDetail.net_weight.isError ? `${validationFormDetail.net_weight.message}` : ''}
                placeholder='Input net weight'
                size='xs'
                withAsterisk
              />
            </Box>
            <Box>
              <NumberInput
                name='gross_weight'
                label="G.W.(KGS)"
                value={formDataDetail.gross_weight}
                onChange={(value) => handleChangeForm('gross_weight', value)}
                error={validationFormDetail.gross_weight.isError ? `${validationFormDetail.gross_weight.message}` : ''}
                placeholder='Input quantity'
                size='xs'
                withAsterisk
              />
            </Box>
            <Box>
              <Select
                name='dimension_unit'
                value={formDataDetail.dimension_unit}
                onChange={(value) => handleChangeForm('dimension_unit', value)}
                error={validationFormDetail.dimension_unit.isError ? `${validationFormDetail.dimension_unit.message}` : ''}
                label='Dimension Unit'
                placeholder='Select unit'
                data={defaultDimensionUnit}
                size='xs'
                withAsterisk
                allowDeselect={false}
              />
            </Box>
            <Box>
              <NumberInput
                name='width'
                label="Package Width"
                value={formDataDetail.width}
                rightSection={<Text fz='xs' c='black' tt='capitalize'>{formDataDetail.dimension_unit}</Text>}
                onChange={(value) => handleChangeForm('width', value)}
                error={validationFormDetail.width.isError ? `${validationFormDetail.width.message}` : ''}
                placeholder='Input width'
                size='xs'
                withAsterisk
                rightSectionWidth={50}
              />
            </Box>
            <Box>
              <NumberInput
                name='height'
                label="Package Height"
                value={formDataDetail.height}
                rightSection={<Text fz='xs' c='black' tt='capitalize'>{formDataDetail.dimension_unit}</Text>}
                onChange={(value) => handleChangeForm('height', value)}
                error={validationFormDetail.height.isError ? `${validationFormDetail.height.message}` : ''}
                placeholder='Input height'
                size='xs'
                withAsterisk
                rightSectionWidth={50}
              />
            </Box>
            <Box>
              <NumberInput
                name='length'
                label="Package Length"
                value={formDataDetail.length}
                rightSection={<Text fz='xs' c='black' tt='capitalize'>{formDataDetail.dimension_unit}</Text>}
                onChange={(value) => handleChangeForm('length', value)}
                error={validationFormDetail.length.isError ? `${validationFormDetail.length.message}` : ''}
                placeholder='Input length'
                size='xs'
                withAsterisk
                rightSectionWidth={50}
              />
            </Box>
          </SimpleGrid>
        </Box>
      )
    }
    
    return (
      <Box>
        <Box mb='lg' mx='sm'>
          <Stepper active={activeStepForm} onStepClick={setActiveStepForm} allowNextStepsSelect={false} completedIcon={<IconCircleCheck size={20} />}>
            <Stepper.Step label="Choose Items" description="Step 1" icon={<IconShoppingCart size={20} />}>
              {mappingFormItems()}
            </Stepper.Step>
            <Stepper.Step label="Item Specification" description="Step 2" icon={<IconInfoSquare size={20} />}>
              {mappingSelectedItems()}
            </Stepper.Step>
            <Stepper.Step label="Package Detail" description="Step 3" icon={<IconPackage size={20} />}>
              {mappingFormDetail()}
            </Stepper.Step>
          </Stepper>
        </Box>
        <Box mt={20}>
          <Flex justify='flex-end'>
            <Group>
              <Button size='xs' variant="outline" onClick={() => activeStepForm === 0 ? onCloseForm() : prevStep()}>{activeStepForm === 0 ? 'Close' : 'Prev Step'}</Button>
              <Button size='xs' variant="filled" loading={loadingForm} onClick={() => activeStepForm < 2 ? handleNextStep() : submitPackageItems()}>{activeStepForm < 2 ? 'Next Step' : 'Submit'}</Button>
            </Group>
          </Flex>
        </Box>
      </Box>
    )
  }

  return (
    <Box>
      {loadingProduct ? <LoadingData /> : loadForm()}
    </Box>
  )
}

export default FormAdjustPackageItem